<script setup>
import Header from '@/components/common/Header.vue'
import TopHeader from '@/components/common/TopHeader.vue'
import Footer from '@/components/common/Footer.vue'
// 引入联系悬浮组件
import ContactFloat from '@/components/common/ContactFloat.vue'
// 公众号二维码（客户提供）——用 import 让 Vite 打包，避免原来裸路径在生产环境 404
import qrWechatMp from '@/assets/images/qr/wechat-mp.jpg'
import { ref, onMounted } from 'vue'
import { fetchMenus } from '@/api/menu'

const menuData = ref(null)

onMounted(async () => {
  try {
    menuData.value = await fetchMenus()
  } catch (error) {
    console.error('获取菜单数据失败:', error)
  }
})
</script>

<template>
  <div class="app-wrapper">
    <!-- 顶部导航相关组件 -->
    <TopHeader></TopHeader>
    <Header :menu-data="menuData" />
    
    <!-- 页面主体内容 -->
    <main class="main-content">
      <router-view />
    </main>
    
    <!-- 页脚 -->
    <Footer />
    
    <!-- 悬浮联系组件：放在最外层，确保在所有内容上方 -->
    <ContactFloat
      phone="13501251657"
      email="info@feaonline.com.cn"
      wechatName="有限元在线"
      :qrcodeUrl="qrWechatMp"
    />
  </div>
</template>

<style scoped>
.app-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 1200px;
  /* 注意：不要给app-wrapper设置overflow:hidden，否则可能遮挡悬浮组件 */
}

.main-content {
  flex: 1;
  min-height: 1200px;
}
</style>